var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrganizationIcon = function SvgOrganizationIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 9.5H11.0625V7.125C11.0625 7.05625 11.0063 7 10.9375 7H7.0625V5.5H8.75C8.8875 5.5 9 5.3875 9 5.25V0.75C9 0.6125 8.8875 0.5 8.75 0.5H4.25C4.1125 0.5 4 0.6125 4 0.75V5.25C4 5.3875 4.1125 5.5 4.25 5.5H5.9375V7H2.0625C1.99375 7 1.9375 7.05625 1.9375 7.125V9.5H0.3125C0.175 9.5 0.0625 9.6125 0.0625 9.75V14.25C0.0625 14.3875 0.175 14.5 0.3125 14.5H4.8125C4.95 14.5 5.0625 14.3875 5.0625 14.25V9.75C5.0625 9.6125 4.95 9.5 4.8125 9.5H3.0625V8.125H9.9375V9.5H8.1875C8.05 9.5 7.9375 9.6125 7.9375 9.75V14.25C7.9375 14.3875 8.05 14.5 8.1875 14.5H12.6875C12.825 14.5 12.9375 14.3875 12.9375 14.25V9.75C12.9375 9.6125 12.825 9.5 12.6875 9.5ZM3.875 10.6875V13.3125H1.25V10.6875H3.875ZM5.1875 4.3125V1.6875H7.8125V4.3125H5.1875ZM11.75 13.3125H9.125V10.6875H11.75V13.3125Z",
    fill: "black",
    fillOpacity: 0.85
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrganizationIcon);
export default ForwardRef;